import { ReactNode, Suspense } from "react";
import { Navbar } from "@/components/Navbar";
import { IndustryBreadcrumb } from "./IndustryBreadcrumb";
import { IndustryLoading } from "./IndustryLoading";
import { Footer } from "@/components/Footer";

interface IndustryLayoutProps {
  children: ReactNode;
  industryName: string;
  className?: string;
}

export const IndustryLayout = ({ children, industryName, className = "" }: IndustryLayoutProps) => {
  return (
    <Suspense fallback={<IndustryLoading />}>
      <div className={`min-h-screen ${className}`}>
        <Navbar />
        <IndustryBreadcrumb industryName={industryName} />
        <main>
          {children}
        </main>
        <Footer />
      </div>
    </Suspense>
  );
};